import { render, staticRenderFns } from "./comp_NewsletterContent.vue?vue&type=template&id=38c6c8f9&"
import script from "./comp_NewsletterContent.vue?vue&type=script&lang=js&"
export * from "./comp_NewsletterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports